import * as React from "react";
import { forwardRef } from "react";
const SvgDot = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 5, height: 4, viewBox: "0 0 5 4", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M4.54688 1.88477V1.90234C4.54688 2.9043 3.75586 3.69531 2.75391 3.69531H2.73633C1.73438 3.69531 0.943359 2.9043 0.943359 1.90234V1.88477C0.943359 0.882812 1.73438 0.0917969 2.73633 0.0917969H2.75391C3.75586 0.0917969 4.54688 0.882812 4.54688 1.88477Z", fill: "#828282" }));
const ForwardRef = forwardRef(SvgDot);
export default ForwardRef;
